import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { GerenciarRecadastramentoService } from '@app/shared/services/gerenciar-recadastramento.service';
import { MensagemService } from '@app/shared/services/mensagem.service';
import { SeguradoService } from '@app/shared/services/segurado.service';

import { environment } from '@environments/environment';
import { Censo, Loading, Segurado } from '@app/shared/models';
import { CensoService } from '@app/shared/services/censo.service';

@Component({
  selector: 'app-otp-sms',
  templateUrl: './otp-sms.component.html',
  styleUrls: ['./otp-sms.component.scss']
})
export class OtpSmsComponent {

  cliente = environment.cliente;
  carregar = new Loading();
  form: FormGroup;
  segurado: Segurado
  numeroCelular: string;
  censo: Censo;

  constructor(
    public dialogRef: MatDialogRef<OtpSmsComponent>,
    private seguradoService: SeguradoService,
    private fb: FormBuilder,
    private mensagemService: MensagemService,
    private gerenciarRecadastramentoService: GerenciarRecadastramentoService,
    private censoService: CensoService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { segurado: Segurado, numeroCelular: string }
  ) {
    this.censo = this.censoService.retornarSessionStorage('censo');
    this.segurado = data.segurado;
    this.numeroCelular = data.numeroCelular;

    this.form = this.fb.group({
      primeiroNumero: [null, Validators.required],
      segundoNumero: [null, Validators.required],
      terceiroNumero: [null, Validators.required],
      quartoNumero: [null, Validators.required]
    });
  }

  validarNumeroDigitado(event: any, index: number): void {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
  }

  mudarInput(event: any, index: number): void {
    const form = document.getElementById('form-opt');
    const inputs = form.querySelectorAll('input');
    const botaoEnviar = document.getElementById('btn-enviar');

    if (inputs[index - 1].value !== '' && index != 4) {
      inputs[index].focus();

    } else if (inputs[index - 1].value === '' && index > 1) {
      inputs[index - 2].focus();
    } else if (index == 4){
      botaoEnviar.focus();
    }
  }

  get codigoSMS(): string {
    const codigo: number[] = [
      this.form.get('primeiroNumero').value,
      this.form.get('segundoNumero').value,
      this.form.get('terceiroNumero').value,
      this.form.get('quartoNumero').value,
    ]
    return codigo.map(String).join('');
  }

  enviarCodigo(): void {
    if (this.form.invalid) return this.mensagemService.avisoMensagemAlerta('Preencha o código completo antes de enviar');

    this.seguradoService.validarCodigoCelular(this.segurado.id, {codigo: this.codigoSMS}, this.carregar).subscribe(() => {
      this.gerenciarRecadastramentoService.setValidacao(true);
    })
  }

  reenviarCodigo(): void {
    this.seguradoService.enviarCodigoCelular(this.segurado.id, { celular: this.numeroCelular }, this.carregar).subscribe(() => {
      this.mensagemService.avisoMensagemInfo('Código reenviado, verifique o seu celular');
    });
  }

}
